import React from "react";
import ExistingEntitySearch from "../components/interactions/search/ExistingEntitySearch";
import Breadcrumbs from "../components/nav/Breadcrumbs";
import CareSenseModal from "../components/nav/modal/CareSenseModal";
import GlobalFooter from "../components/nav/navbars/GlobalFooter";
import RootInteractionNavBar from "../components/nav/navbars/RootInteractionNavBar";
import { useStoreSelector } from "../store/Hooks";
import { Outlet } from "react-router-dom";
import CareSenseAlert from "../components/nav/modal/CareSenseAlert";

// const Layout = styled("div")(({ theme }) => ({
//   minHeight: "600px",
// }));

export default function RootLayout({ children }: any) {
  // const dispatch = useStoreDispatch();
  const navHistoryNodes = useStoreSelector((state) => state.nav.navHistory);
  const previewMode = useStoreSelector((state) => state.nav.previewMode);
  
  /* handle modal contents */
  // alerts
  const caresenseModalOpen = useStoreSelector((state) => state.nav.caresenseModalOpen);
  const caresenseModalAlertType = useStoreSelector((state) => state.nav.caresenseModalAlertType);
  const caresenseModalAlertMessage = useStoreSelector((state) => state.nav.caresenseModalAlertMessage);
  const caresenseModalAlertEntityID = useStoreSelector((state) => state.nav.caresenseModalAlertEntityID);

  // existing entity search
  const existingInteractionSearchType = useStoreSelector((state) => state.nav.existingInteractionSearchType);

  
  return (
    <>
      <CareSenseModal>
        {caresenseModalOpen && existingInteractionSearchType && <ExistingEntitySearch />}
        {caresenseModalOpen && caresenseModalAlertType && <CareSenseAlert type={caresenseModalAlertType} message={caresenseModalAlertMessage} id={caresenseModalAlertEntityID}/>}
      </CareSenseModal>
      {!previewMode && <RootInteractionNavBar />}
      {!previewMode && navHistoryNodes.length > 0 && <Breadcrumbs />}
      <Outlet />
      {!previewMode && <GlobalFooter />}
    </>
  );
}
